export default __webpack_public_path__ + "static/media/veer1.882cc67a.png";